import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import PostalMime, { Email } from 'postal-mime';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { ViewManagerService } from 'src/app/core/services/view-manager-service';
import { SpinnerService } from '../../spinner-load/spinner.service';
import { DocPreviewUtilityService } from '../doc-preview-utility.service';
import { UrlSettingsCore } from 'src/app/core/configuration/url-settings-core';
import { Title } from '@angular/platform-browser';
import { UserProfileFlagStore } from 'src/app/utility/store/user-profile-flag';
import { DialogService } from 'src/app/core/components/dialog/dialog.service';
import { ConfirmModalComponent } from 'src/app/core/components/dialog/components/confirm-modal/confirm-modal.component';

@Component({
  selector: 'main [app-eml-preview]',
  templateUrl: './eml-preview.component.html',
  host: { '[attr.id]': '\'content\'' },
  styleUrls: ['./eml-preview.component.css']
})
export class EmlPreviewComponent {
  idDocument: string = null;
  email: Email = null;
  isAllegatoPreview = false;
  mainPreview: Email = null;
  breadCrumb: Array<Email> = [];
  activeIndex: number = 0;
  constructor(
    private helpers: HelpersService,
    private route: ActivatedRoute,
    private spinner: SpinnerService, 
    private router: Router,
    private viewManager: ViewManagerService,
    private docUtilityService: DocPreviewUtilityService,
    private title: Title,
    private dialog: DialogService
  ) {}

  ngOnInit(){
    this.viewManager.svuotaMenu();
    this.viewManager.showHeader();
    window.opener?.postMessage('child_ready', window.location.origin);
    window.addEventListener('message', this.onMessageReceived.bind(this), false);
    const nomeFile = this.route.snapshot.queryParamMap.get('nomeFile');
    this.title.setTitle("Teleforum - " + nomeFile);
    this.idDocument = this.route.snapshot.paramMap.get('idDocumento')!;
    this.route.data.subscribe(data => {
      if(!!data['documento'] && typeof data['documento'] === "object") {
        this.mainPreview = data['documento'];
        this.email = data['documento'];
        let found = this.breadCrumb.findIndex(itm => itm.messageId === data['documento'].messageId) > -1;
        if(!found) {
          this.breadCrumb.push(data['documento']);
        }
        this.activeIndex = this.breadCrumb.findIndex(itm => itm.messageId === data['documento'].messageId);
      }
    });
  }

  onMessageReceived(event: MessageEvent) {
    if (event.origin !== window.location.origin) {
      console.warn('Origine non valida:', event.origin);
      return;
    }

    const content = event?.data?.content;
    if(!!content) {
      this.spinner.show();
      PostalMime.parse(content).then(email => {
        this.mainPreview = email;
        this.email = email;
        let found = this.breadCrumb.findIndex(itm => itm.messageId === email.messageId) > -1;
        if(!found) {
            this.breadCrumb.push(email);
          }
        this.activeIndex = this.breadCrumb.findIndex(itm => itm.messageId === email.messageId);
        this.spinner.hide();
      });
    }
  }

  getDocPreviewByIdDocument(idDocument:string) {
    this.spinner.show();
    this.helpers.getPreview(idDocument).subscribe((res) => {
        let emlData = res.body;
        PostalMime.parse(emlData, {attachmentEncoding:"base64"}).then(email => {
          this.mainPreview = email;
          this.email = email;
          let found = this.breadCrumb.findIndex(itm => itm.messageId === email.messageId) > -1;
          if(!found) {
            this.breadCrumb.push(email);
          }
          this.activeIndex = this.breadCrumb.findIndex(itm => itm.messageId === email.messageId);
          this.spinner.hide();
        });
    });
  }

  async getDocPreviewByBuffer(content: string) {
    const emlUint8Array = this.docUtilityService.base64ToUint8Array(content);
    await PostalMime.parse(emlUint8Array).then(email => {
        this.email = email;
        let found = this.breadCrumb.findIndex(itm => itm.messageId === email.messageId) > -1;
        if(!found) {
          this.breadCrumb.push(email);
        }
        this.activeIndex = this.breadCrumb.findIndex(itm => itm.messageId === email.messageId);
        this.spinner.hide();
    });
  }

  getConcatenatedAddresses(array, param): string {
    return array?.map(item => item[param]).join('; ');
  }

  rendereBodyText(text) {
    return text?.replace(/\n/g, '<br>');
  }

  openAttachmentPreview(doc: {description: string, content: any, mimeType: string, filename?: string }, ext = null) {
    const filename = doc.filename || doc.description;
    const extension = ext ? ext : filename.substring(filename.lastIndexOf('.') + 1);
    switch (extension) {
      case EXTENSIONS.EML:
        // this.email = null;
        this.isAllegatoPreview = true;
        this.spinner.show();
        if(typeof doc.content === "string") {
          this.getDocPreviewByBuffer(doc.content)
        } else {
          PostalMime.parse(doc.content).then(email => {
            this.email = email;
            let found = this.breadCrumb.findIndex(itm => itm.messageId === email.messageId) > -1;
            if(!found) {
              this.breadCrumb.push(email);
            }
            this.activeIndex = this.breadCrumb.findIndex(itm => itm.messageId === email.messageId);
            this.spinner.hide();
          });
        }
        break;
      case EXTENSIONS.ZIP:
        this.openExitPreview(doc, UrlSettingsCore.URL_ZIP_FILE_PREVIEW);
        break;
      case EXTENSIONS.PDF:
        if(doc.content instanceof ArrayBuffer) {
          doc.content = this.docUtilityService.arrayBufferToBase64(doc.content);
        }
        this.openExitPreview(doc, UrlSettingsCore.URL_PDF_FILE_PREVIEW);
        break;
      case EXTENSIONS.P7M:
        this.handleP7m(doc);
        break;
      default:
        this.dialogNoPreview();
        break;
    }
  }

  private handleP7m(doc: { description: string; content: any; mimeType: string; filename?: string; }) {
    let body = { fileData: {} };
    let content;
    if(doc.content instanceof ArrayBuffer) {
      content = this.docUtilityService.arrayBufferToBase64(doc.content);
    } else {
      content = doc.content;
    }
    body.fileData["content"] = content;
    body.fileData["nomeFile"] = doc.filename;
    body.fileData["contentType"] = doc.mimeType;
    body.fileData["descrizione"] = doc.description;
    this.docUtilityService.extractPdfFromP7m(body).subscribe(
      res => {
        const contentDisposition = res.headers.get('Content-Disposition');
        const { filename, extension } = this.docUtilityService.parseContentDisposition(contentDisposition);
        const mimeType = res.headers.get('content-type');
        let docNew = {
          content: this.docUtilityService.arrayBufferToBase64(res.body),
          mimeType: mimeType,
          description: doc.description,
          filename: filename
        };
        if (extension === EXTENSIONS.PDF) {
          this.openExitPreview(docNew, UrlSettingsCore.URL_PDF_FILE_PREVIEW);
        } else {
          this.openAttachmentPreview(docNew, extension);
        }
      }
    );
  }

  private dialogNoPreview() {
    this.dialog.open(ConfirmModalComponent, {
      data: {
        modalConfirm: {
          text: "Anteprima non supportata per questo documento",
          hideButtons: true,
          confirmButton: true
        },
        style: { width: "30%" },
        title: "Errore",
      }
    });
  }

  private openExitPreview(doc: { description: string; content: any; mimeType: string; filename?: string; }, route) {
    const newWindow = window.open(`${window.location.origin + (location.pathname && location.pathname !== '' ? location.pathname : '/')}#/${route}/buffer?nomeFile=${doc.description || doc.filename}`, '_blank');
    const payload = {
      content: doc.content,
      name: doc.description || doc.filename,
      mimeType: doc.mimeType
    };
    const listener = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) return;
      if (event.data === 'child_ready') {
        newWindow?.postMessage(payload, window.location.origin);
        window.removeEventListener('message', listener);
      }
    };
    window.addEventListener('message', listener, false);
  }

  showMainAttachment() {
    this.isAllegatoPreview = false;
    this.email = this.mainPreview;
  }

  openDynamicFile(file: { content: string, mimeType: string, filename?: string }) {
    let blob: any;
    if(typeof file.content !== "string") {
      blob = new Blob([file.content], { type: file.mimeType });
    } else {
      const byteArray = this.docUtilityService.base64ToUint8Array(file.content);
      blob = new Blob([byteArray], { type: file.mimeType });
    }
    const url = URL.createObjectURL(blob);
    window.open(url);
  }

  truncate(text: string, chars:number) {
    if(!text) return;
    return text.length > chars ? text.slice(0, chars) + " ... " : text;
  }

  grabState(index: number) {
    this.email = this.breadCrumb[index];
    this.activeIndex = index;
  }

  canViewFile(file: { content: ArrayBuffer |string, mimeType: string, filename?: string }){
    if(!file) return false;
    const extension = file.filename.substring(file.filename.lastIndexOf('.') + 1).toLowerCase();
    if(extension !== "pdf" && extension !== "eml" && extension !== "zip" && extension !== "p7m") return false;
    let maxPreviewSize = this.docUtilityService.findMaxSizeByContentype(file.mimeType);
    let bytes;
    if(file.content instanceof ArrayBuffer) {
      bytes = file.content.byteLength;
    } else {
      bytes = this.docUtilityService.base64ToUint8Array(file?.content);
    }
    // controllo che il contenuto del file non superi la dimensione massima consentita
    if(bytes.length > Number(!!maxPreviewSize ? maxPreviewSize : bytes.length)) {
      file["maxLimitExceeded"] = true;
      return false;
    };
    return true;
  }
}

export enum EXTENSIONS {
  EML = "eml",
  PDF = "pdf",
  ZIP = "zip",
  P7M = "p7m"
}

export const mimeExtensionMap: { [key: string]: string } = {
  'application/pdf': 'pdf',
  'text/plain': 'txt',
  'image/png': 'png',
  'image/jpeg': 'jpg',
  'application/msword': 'doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  'application/vnd.ms-excel': 'xls',
  'application/zip': 'zip', 
  'message/rfc822': 'eml',
  'application/pkcs7-mime': 'p7m',
  'application/x-pkcs7-mime': 'p7m',
  'application/octet-stream': 'bin'
};